<template>
  <div v-loading="loading">
    <!-- form -->
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <!-- 車輛信息 -->
      <form-box :title="$t('hzmbG.title.vehicle')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbH.label.registrationNo')">
                <el-input v-model="form.registrationNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('message.spNo')">
                <el-input
                  v-model="form.firstApplicationCaseNo"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <!-- 車輛信息 -->
      <form-box :title="$t('hzmbH.title.canceklInfo')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbH.label.cancelReason')"
                :prop="`cancelReason`"
                :rules="[ruleList.notNull]"
              >
                <el-select v-model="form.cancelReason">
                  <el-option
                    v-for="(item, index) in reasons"
                    :key="index"
                    :label="item[`name${$t('message.lan')}`]"
                    :value="item[`name${$t('message.lan')}`]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24">
              <el-form-item
                :label="$t('hzmbH.label.cancelReason')"
                prop="cancelReason"
                :rules="[ruleList.notNull]"
              >
                <el-input
                  v-model="form.cancelReason"
                  :rows="3"
                  type="textarea"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </div>
      </form-box>
      <!-- end -->
    </el-form>
    <!-- 下一步 -->
    <div v-if="form.id" class="next_btn">
      <GradientBtn @click="onSubmitClick" :loading="submitLoading"
        >{{ $t("message.DataRegistration.check.submit") }}
      </GradientBtn>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import { getDetail, submit } from "@/api/hzmb-gh/HzmbHApplicationApi";
import ReasonTemplateAPI from "@/api/hzmb-gh/ReasonTemplateAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import FormBox from "../components/FormBox.vue";

export default {
  components: { FormBox, GradientBtn },
  data() {
    return {
      serviceType: null,
      loading: false,
      submitLoading: false,
      form: {},
      ruleList: {
        notNull: {
          required: true,
          message: this.$t("message.formRuleMessage.notNull"),
        },
      },
      reasons: [],
    };
  },
  computed: {
    isDev() {
      return process.env.VUE_APP_ENV === "development";
    },
    isPerson() {
      return ["HZMB_H_FIRST_PERSON"].includes(this.serviceType);
    },
    isCompany() {
      return ["HZMB_H_FIRST_COMP"].includes(this.serviceType);
    },
  },
  created() {
    this.getSomething();
  },
  methods: {
    //
    async getSomething() {
      this.loading = true;

      try {
        let { f = "" } = this.$route.query;
        this._verifyForm =
          JSON.parse(localStorage.getItem(`verifyFormH${f}`)) || {};
        let { serviceType, registrationNo, identificationNo } =
          this._verifyForm;
        this.serviceType = serviceType;
        this.reasons = await ReasonTemplateAPI.getReasons(this.serviceType);

        let { id, firstApplicationCaseNo } = await getDetail({
          serviceType,
          registrationNo,
          identificationNo,
        });
        this.form.registrationNo = registrationNo;
        this.form.id = id;
        this.form.firstApplicationCaseNo = firstApplicationCaseNo ?? "-";
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    //
    async onSubmitClick() {
      this.submitLoading = true;
      try {
        await this.$refs["form"].validate();

        await this.$confirm(
          this.$t("message.confirm_submit_content"),
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        );

        let result = await submit({
          serviceType: this.serviceType,
          id: this.form.id,
          cancelReason: this.form.cancelReason,
        });
        
        let query = {
          ...this.$route.query,
          id: this.form.id,
          applicationNo: result.applicationNo,
        };
        this.$router.push({
          path: "/hzmb-h-first/success",
          query,
        });
      } catch (error) {
        if (error === false)
          this.$message({
            type: "error",
            message: this.$t("message.form_error"),
          });
        else if (error === "cancel") return;
        else this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 46px;
}
.el-input-number {
  line-height: 46px;
}
.m-form__items {
  .el-textarea {
    margin-bottom: 8px;
  }
}
.el-row {
  align-items: flex-start;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
.vehicle-size-row {
  .el-input {
    margin-bottom: 22px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"] {
  -moz-appearance: textfield;
}
.el-form /deep/.el-textarea__inner[rows] {
  height: auto;
}
</style>
